import Namer from '../Generic/Namer';

export default Namer('sensortypes');


// WEBPACK FOOTER //
// ./src/container/SensorType/SensorTypeName.tsx